import '@/styles/design-system-css-develop/index.css'
import 'quasar/src/css/index.sass'

import { createApp } from 'vue'
import { Quasar, Notify, Loading, Dialog } from 'quasar'
import quasarIconSet from 'quasar/icon-set/svg-fontawesome-v6'

import i18n from '@/plugins/i18n'
import sentry from '@/plugins/sentry'
import sanitizer from '@/plugins/sanitizer'
import veevalidate from '@/plugins/veevalidate'
import pinia from '@/plugins/pinia'
import tanstack from '@/plugins/tanstack'
import '@/common/plugins/quasar'

import { faAngleDown, faArrowDownArrowUp } from '@fortawesome/pro-regular-svg-icons'

import fontAwesome from '@/plugins/font-awesome'

import App from '@/App.vue'
import router from '@/router'

import eventBus from '@/plugins/eventBus'
import { getInlineIcon } from '@/common/helpers/icon'
import VueBbob from '@bbob/vue3'

quasarIconSet.arrow.dropdown = getInlineIcon(faAngleDown)
quasarIconSet.table.arrowUp = getInlineIcon(faArrowDownArrowUp)

const app = createApp(App)

app.use(pinia, { router })
app.use(tanstack)
app.use(router)
app.use(i18n)
app.use(Quasar, {
  plugins: { Dialog, Notify, Loading },
  iconSet: quasarIconSet,
})
app.use(sanitizer)
app.use(veevalidate)
app.use(fontAwesome)
app.use(eventBus)
app.use(sentry, { router })
app.use(VueBbob)
app.mount('#assist-controller')

console.log('assist is loaded')
